import React, { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext(null);

const dict = {
  de: {
    nav: {
      features: "Features",
      pricing: "Preise",
      faq: "FAQ",
      contact: "Kontakt",
      login: "Anmelden",
      start: "Jetzt starten",
      dashboard: "Dashboard",
      logout: "Abmelden",
    },
    hero: {
      eyebrow: "Die TikTok Shop Agentur Nr.1 in DACH",
      creatorTitle: "Verwandle deine\nViews in Umsatz.",
      brandTitle: "Verkaufe dein Produkt\nüber Tausende Creator.",
      creatorSub: "Erhalte gratis Produkte, exklusive Brand-Deals und höhere Provisionen – betreut von einem Team, das viral versteht.",
      brandSub: "Wir matchen dein Produkt mit den richtigen TikTok Shop Creators. Performance-basiert, kein Bullshit.",
      ctaCreator: "Mit uns sprechen",
      ctaBrand: "Mit uns sprechen",
      ctaSecondary: "Wie es funktioniert",
    },
    audience: { creator: "Creator", brand: "Brand" },
    metrics: {
      gmv: "GMV generiert",
      creators: "Creator im Netzwerk",
      campaigns: "Aktive Brand-Deals",
      retention: "Creator-Retention",
    },
    marquee: ["BEAUTY", "FASHION", "TECH", "FITNESS", "HOME", "FOOD", "LIFESTYLE", "WELLNESS", "GADGETS", "PETS"],
    marqueeLabel: "Wir bringen Creator und Produkte zusammen aus:",
    features: {
      title: "Alles was du brauchst,\nan einem Ort.",
      subtitle: "Eine vertikal integrierte Plattform für TikTok Shop – von der ersten Probe bis zum siebenstelligen Umsatz.",
      trendsTitle: "Trends Radar",
      trendsDesc: "Sehe in Echtzeit, welche Produkte heute viral gehen – bevor andere es bemerken.",
      samplesTitle: "Gratis Muster",
      samplesDesc: "Pro-Mitglieder erhalten kostenlose Produktproben direkt zu sich nach Hause.",
      dealsTitle: "Exklusive Brand-Deals",
      dealsDesc: "Zugriff auf Kampagnen, die nicht öffentlich gelistet sind. Höhere Provisionen, weniger Konkurrenz.",
      analyticsTitle: "Performance Analytics",
      analyticsDesc: "Tracke deine Views, Conversion und Earnings pro Video – mit datenbasierten Hooks.",
      managerTitle: "Persönlicher Manager",
      managerDesc: "Priority Support, schnelle Auszahlungen und ein Mensch, der deinen Account betreut.",
      networkTitle: "Creator Netzwerk",
      networkDesc: "Tausche dich aus, kollaboriere und finde Inspiration in der ViralCrew Community.",
    },
    pricing: {
      title: "Wähle deinen Plan.",
      subtitle: "Starte gratis. Upgrade wenn du bereit bist zu skalieren.",
      free: "Free",
      pro: "Pro",
      perMonth: "/Monat",
      freeAmount: "Kostenlos",
      proAmount: "19,99 €",
      mostPopular: "Beliebt",
      freeCta: "Kostenlos starten",
      proCta: "Pro freischalten",
      rows: [
        { label: "Agentur-Verknüpfung",            free: "Standard",            pro: "Premium" },
        { label: "Zugriff auf Produktlinks",       free: "Zugriff",             pro: "Voller Zugriff" },
        { label: "Provisionen",                    free: "Mehr Provisionen",    pro: "Höchster Provisionssatz" },
        { label: "Kampagnen",                      free: "Ausgewählte Kampagnen", pro: "Exklusive Kampagnen" },
        { label: "Gratis Produktmuster",           free: false,                 pro: true },
        { label: "Support",                        free: "Standard Support",    pro: "Priority Support" },
        { label: "Persönlicher Ansprechpartner",   free: false,                 pro: true },
        { label: "Regelmäßige Calls",              free: false,                 pro: true },
        { label: "1:1 Call mit unserem Team",      free: false,                 pro: true },
        { label: "Unterstützung bei Sperren & Verstößen", free: false,          pro: true },
        { label: "Early Access zu neuen Deals",    free: false,                 pro: true },
        { label: "Wöchentliche Performance-Analyse", free: false,               pro: true },
        { label: "Retainer-Möglichkeiten",         free: false,                 pro: true },
      ],
    },
    contact: {
      title: "Lass uns reden.",
      subtitle: "Drei schnelle Wege uns zu erreichen – oder schreib uns direkt eine Nachricht.",
      whatsapp: "Auf WhatsApp",
      whatsappSub: "Schnellste Antwort · 24h",
      discord: "Discord Community",
      discordSub: "1.200+ Creator chatten gerade",
      whop: "Bei Whop ansehen",
      whopSub: "Pro-Mitgliedschaft sichern",
      formTitle: "Oder per Nachricht",
      name: "Name",
      email: "E-Mail",
      handle: "TikTok Handle / Firma",
      phone: "Telefon (optional)",
      mobile: "Mobil (optional)",
      message: "Worum geht's?",
      submit: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Erhalten! Wir melden uns innerhalb von 24h.",
    },
    faq: {
      title: "Häufige Fragen",
      tabs: { creator: "Für Creator", brand: "Für Brands" },
      creator: [
        { q: "Wie viel verdiene ich als Creator?", a: "Im Schnitt zwischen 500 € und 15.000 € pro Monat – abhängig von Reichweite, Nische und Performance. Top-Creator generieren sechsstellige Beträge." },
        { q: "Was kostet der Free-Plan wirklich?", a: "Nichts. Keine versteckten Kosten. Du startest mit Agentur-Verknüpfung, Zugriff auf Produktlinks und ausgewählten Kampagnen." },
        { q: "Wie funktioniert das mit den Gratis-Mustern?", a: "Pro-Mitglieder können regelmäßig Produkte aus unserem Katalog anfordern – versandkostenfrei direkt zu dir." },
        { q: "Kann ich jederzeit kündigen?", a: "Ja. Monatlich kündbar, keine Mindestlaufzeit. Bezahlung läuft sicher über Whop." },
        { q: "Brauche ich eine bestimmte Follower-Zahl?", a: "Nein, wir nehmen auch Micro-Creator. Was zählt ist Engagement und Content-Qualität, nicht reine Follower." },
      ],
      brand: [
        { q: "Wie läuft eine Kampagne ab?", a: "Du briefst dein Produkt, wir matchen dich mit Creators, du zahlst nur für tatsächliche Performance. Wir kümmern uns um Logistik und Reporting." },
        { q: "Was kostet eine Brand-Kooperation?", a: "Modular: Setup-Fee + Provision pro Sale oder CPM. Wir machen dir ein kostenloses Angebot nach dem Erstgespräch." },
        { q: "Wie schnell kann eine Kampagne live gehen?", a: "Von Briefing bis ersten Posts in der Regel 10–14 Tage. Bei eiligen Launches schneller." },
        { q: "Bekomme ich Reporting?", a: "Ja. Wöchentliche Performance-Reports mit Views, GMV, ROAS und allen Creator-Videos in einem Dashboard." },
      ],
    },
    footer: {
      tagline: "Die TikTok Shop Agentur, die Creator zuerst denkt.",
      product: "Produkt",
      legal: "Rechtliches",
      copyright: "© 2026 ViralCrew. Alle Rechte vorbehalten.",
      madeBy: "made by ViralCrew",
    },
    auth: {
      loginTitle: "Willkommen zurück",
      loginSub: "Melde dich in deinem ViralCrew Account an. Accounts werden von uns erstellt – melde dich bei Interesse über das Kontaktformular.",
      email: "E-Mail",
      password: "Passwort",
      submitLogin: "Anmelden",
      withGoogle: "Mit Google anmelden",
      or: "oder",
      noAccount: "Noch kein Account?",
      contactUs: "Schreib uns",
      side: {
        titlePre: "Verwandle deine ",
        titleHighlight: "Views",
        titlePost: " in Umsatz.",
        sub: "Schließe dich 70+ Creators und Brands an, die mit uns auf TikTok Shop skalieren.",
        statGmv: "Top-GMV / Woche",
        statCreators: "Creator",
        statRetention: "Retention",
      },
    },
    dashboard: {
      welcome: "Willkommen",
      overview: "Übersicht",
      trends: "Trends",
      campaigns: "Kampagnen",
      samples: "Muster",
      profile: "Profil",
      plan: "Plan",
      upgrade: "Auf Pro upgraden",
      proActive: "Pro aktiv",
      stats: { earnings: "Earnings", views: "Views", campaigns: "Aktive Kampagnen", samples: "Bestellte Muster" },
      lockedPro: "Sperre Pro frei, um diese Kampagne zu sehen.",
      requestSample: "Muster anfordern",
      noSamples: "Du hast noch keine Muster bestellt.",
      onlyPro: "Nur für Pro-Mitglieder verfügbar.",
    },
  },
  en: {
    nav: {
      features: "Features", pricing: "Pricing", faq: "FAQ", contact: "Contact",
      login: "Sign in", start: "Get started", dashboard: "Dashboard", logout: "Sign out",
    },
    hero: {
      eyebrow: "The #1 TikTok Shop Agency in DACH",
      creatorTitle: "Turn your\nviews into revenue.",
      brandTitle: "Sell your product\nthrough thousands of creators.",
      creatorSub: "Get free products, exclusive brand deals and higher commissions — handled by a team that gets virality.",
      brandSub: "We match your product with the right TikTok Shop creators. Performance-based, no fluff.",
      ctaCreator: "Talk to us", ctaBrand: "Talk to us", ctaSecondary: "How it works",
    },
    audience: { creator: "Creator", brand: "Brand" },
    metrics: { gmv: "GMV driven", creators: "Creators in network", campaigns: "Active brand deals", retention: "Creator retention" },
    marquee: ["BEAUTY", "FASHION", "TECH", "FITNESS", "HOME", "FOOD", "LIFESTYLE", "WELLNESS", "GADGETS", "PETS"],
    marqueeLabel: "We connect creators and products across:",
    features: {
      title: "Everything you need,\nin one place.",
      subtitle: "A vertically-integrated platform for TikTok Shop — from your first sample to seven-figure revenue.",
      trendsTitle: "Trend radar", trendsDesc: "See which products are going viral in real time — before everyone else notices.",
      samplesTitle: "Free samples", samplesDesc: "Pro members get free product samples shipped straight to their door.",
      dealsTitle: "Exclusive brand deals", dealsDesc: "Access campaigns that aren't listed publicly. Higher commissions, less competition.",
      analyticsTitle: "Performance analytics", analyticsDesc: "Track views, conversion and earnings per video — with data-backed hooks.",
      managerTitle: "Personal manager", managerDesc: "Priority support, fast payouts and a human dedicated to your account.",
      networkTitle: "Creator network", networkDesc: "Connect, collaborate and find inspiration inside the ViralCrew community.",
    },
    pricing: {
      title: "Pick your plan.", subtitle: "Start free. Upgrade when you're ready to scale.",
      free: "Free", pro: "Pro", perMonth: "/month",
      freeAmount: "Free", proAmount: "€19.99",
      mostPopular: "Popular", freeCta: "Start for free", proCta: "Unlock Pro",
      rows: [
        { label: "Agency connection",                free: "Standard",          pro: "Premium" },
        { label: "Product link access",              free: "Access",            pro: "Full access" },
        { label: "Commissions",                      free: "More commissions",  pro: "Highest rates" },
        { label: "Campaigns",                        free: "Selected campaigns", pro: "Exclusive campaigns" },
        { label: "Free product samples",             free: false,               pro: true },
        { label: "Support",                          free: "Standard",          pro: "Priority" },
        { label: "Dedicated manager",                free: false,               pro: true },
        { label: "Regular calls",                    free: false,               pro: true },
        { label: "1:1 call with our team",           free: false,               pro: true },
        { label: "Help with bans & violations",      free: false,               pro: true },
        { label: "Early access to new deals",        free: false,               pro: true },
        { label: "Weekly performance analysis",      free: false,               pro: true },
        { label: "Retainer options",                 free: false,               pro: true },
      ],
    },
    contact: {
      title: "Let's talk.", subtitle: "Three quick ways to reach us — or write us a message.",
      whatsapp: "Via WhatsApp", whatsappSub: "Fastest reply · 24h",
      discord: "Discord community", discordSub: "1,200+ creators online",
      whop: "View on Whop", whopSub: "Get the Pro membership",
      formTitle: "Or send a message",
      name: "Name", email: "Email", handle: "TikTok handle / Company", phone: "Phone (optional)", mobile: "Mobile (optional)", message: "What's it about?",
      submit: "Send message", sending: "Sending...", success: "Got it! We'll reply within 24h.",
    },
    faq: {
      title: "Frequently asked",
      tabs: { creator: "For Creators", brand: "For Brands" },
      creator: [
        { q: "How much do creators earn?", a: "Between €500 and €15,000 per month on average — depending on reach, niche and performance. Top creators generate six-figure revenue." },
        { q: "What does Free really cost?", a: "Nothing. No hidden fees. You start with agency connection, product link access and selected campaigns." },
        { q: "How do free samples work?", a: "Pro members can regularly request products from our catalogue — shipped free, straight to you." },
        { q: "Can I cancel anytime?", a: "Yes. Monthly subscription, no lock-in. Payments processed securely via Whop." },
        { q: "Do I need a certain follower count?", a: "No, we accept micro-creators too. Engagement and content quality matter more than raw follower numbers." },
      ],
      brand: [
        { q: "How does a campaign work?", a: "You brief your product, we match you with creators, you pay only for actual performance. We handle logistics and reporting." },
        { q: "What does a brand collab cost?", a: "Modular: setup fee + commission per sale or CPM. We'll send a free quote after the intro call." },
        { q: "How fast can a campaign go live?", a: "From brief to first posts usually within 10–14 days. Faster for urgent launches." },
        { q: "Do I get reporting?", a: "Yes. Weekly performance reports with views, GMV, ROAS and every creator video in one dashboard." },
      ],
    },
    footer: {
      tagline: "The TikTok Shop agency that puts creators first.",
      product: "Product", legal: "Legal",
      copyright: "© 2026 ViralCrew. All rights reserved.",
      madeBy: "made by ViralCrew",
    },
    auth: {
      loginTitle: "Welcome back",
      loginSub: "Sign in to your ViralCrew account. Accounts are created by us — reach out via the contact form if you're interested.",
      email: "Email", password: "Password",
      submitLogin: "Sign in", withGoogle: "Sign in with Google", or: "or",
      noAccount: "No account yet?", contactUs: "Contact us",
      side: {
        titlePre: "Turn your ",
        titleHighlight: "views",
        titlePost: " into revenue.",
        sub: "Join 70+ creators and brands scaling on TikTok Shop with us.",
        statGmv: "Top GMV / week",
        statCreators: "Creators",
        statRetention: "Retention",
      },
    },
    dashboard: {
      welcome: "Welcome", overview: "Overview", trends: "Trends", campaigns: "Campaigns",
      samples: "Samples", profile: "Profile", plan: "Plan",
      upgrade: "Upgrade to Pro", proActive: "Pro active",
      stats: { earnings: "Earnings", views: "Views", campaigns: "Active campaigns", samples: "Samples ordered" },
      lockedPro: "Unlock Pro to view this campaign.", requestSample: "Request sample",
      noSamples: "You haven't ordered any samples yet.", onlyPro: "Available for Pro members only.",
    },
  },
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    return localStorage.getItem("vc_lang") || "de";
  });
  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("vc_lang", lang);
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const t = dict[lang];
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
